import { render, staticRenderFns } from "./HotelMatchDetail.vue?vue&type=template&id=02bf0c65&scoped=true"
import script from "./HotelMatchDetail.vue?vue&type=script&lang=js"
export * from "./HotelMatchDetail.vue?vue&type=script&lang=js"
import style0 from "./HotelMatchDetail.vue?vue&type=style&index=0&id=02bf0c65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf0c65",
  null
  
)

export default component.exports